export default "__VITE_ASSET__DSZQkaHU__"